import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'asset',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'asset',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'asset',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'asset',
  action: ActionType.UPDATE,
};

export const Asset = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
